module.exports = __webpack_public_path__ + "static/img/ic_hs.c071e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_hs.png
// module id = voNY
// module chunks = 0